// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('equipmentEdit', {
//         templateUrl: 'views/components/views/equipmentEdit/equipmentEdit.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'equipmentEditService', 'logisticService', 'labourPositionService', 'equipmentGrpsService', 'typeaheadService', 'layoutService', function ($stateParams, stateService, utilityService, modalService, translateService, equipmentEditService, logisticService, labourPositionService, equipmentGrpsService, typeaheadService, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let equipmentId = $stateParams.equipment_id;
            
//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 factoryButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') }
//                 ],
//                 workGroupButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') }
//                 ],
//                 workGroupButtonsExpanded: [
//                     { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.workgrp_keyno = '0' },
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('workgrps') }
//                 ],
//                 equipmentGroupButtons: [
//                     { id: 'list', icon: 'fa fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentgrps') }
//                 ],
//                 productIdSelectingButtons: [
//                     {
//                         id: 'goto',
//                         icon: 'fas fa-search',
//                         color: 'primary',
//                         type: 'primary',
//                         onClick: () => stateService.go('selectproduct', {
//                             webpage_name: stateService.getCurrentName(),
//                             parm1: vm.model.edit.equipment_id,
//                             parm2: '0'
//                         })
//                     }
//                 ],
//                 productIdEditingButtons: [
//                     {
//                         id: 'goto',
//                         icon: 'fa fa-chevron-right',
//                         color: 'primary',
//                         type: 'primary',
//                         onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_id })
//                     }
//                 ],
//                 edit: {},
//                 selectListCompanies: [],
//                 selectListFactories: [],
//                 selectListWorkGroups: [],
//                 selectListEquipmentGroups: [],
//                 selectListStockLocations: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await equipmentEditService.getEdit({ equipment_id: equipmentId }))[0];
//             }

//             async function loadCompanies() {
//                 vm.model.selectListCompanies = await logisticService.listCompanies();
//             }

//             async function loadEquipmentGroupViews() {
//                 vm.model.selectListEquipmentGroups = await equipmentGrpsService.listEquipmentGrpViews();
//             }

//             async function loadFactories() {
//                 if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;
                
//                 return vm.model.selectListFactories = await labourPositionService.listSelectFactories({ businessco_no: vm.model.edit.businessco_no });
//             }

//             async function loadSelectWorkGroups() {
//                 if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.edit.factory_id, true) !== true) return;
                
//                 return vm.model.selectListWorkGroups = await equipmentEditService.listSelectWorkGroups({
//                     businessco_no: vm.model.edit.businessco_no,
//                     factory_id: vm.model.edit.factory_id
//                 });
//             }

//             async function loadStockLocations() {
//                 if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;
                
//                 return vm.model.selectListStockLocations = await logisticService.listStockLocation({
//                     stockzoneclass_keyno: '50',
//                     factory_id: vm.model.edit.factory_id
//                 });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             vm.typeaheadSearch = function (value, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit[id] = value;

//                         return typeaheadService.searchProduct({ prod_name: vm.model.edit[id] || '' });
//                         break;
//                     case 'supplier_name':
//                         vm.model.edit[id] = value;

//                         return typeaheadService.searchCustomer({
//                             cust_name: vm.model.edit[id] || '',
//                             filtertype: '',
//                             filtervalue: '',
//                             custtype: 'S',
//                             lastselect: 'SEARCH'
//                         });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

//             // #region SELECTED VALUE FUNCTION

//             vm.onTypeaheadSelected = function (item, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         if (item) {
//                             vm.model.edit.prod_id = item?.item_id ?? '';
//                             vm.model.edit.prod_name = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('prod_name');
//                         }
//                         break;
//                     case 'supplier_name':
//                         if (item) {
//                             vm.model.edit.supplier_no = item?.item_id ?? '0';
//                             vm.model.edit.supplier_name = item?.item_name ?? '';
//                         } else {
//                             vm.onTypeaheadClear('supplier_name');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion SELECTED VALUE FUNCTION

//             // #region CHANGED VALUE FUNCTION

//             vm.onTypeaheadChanged = function (value, item, id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit.prod_name = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.prod_id = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('prod_name');
//                         }
//                         break;
//                     case 'supplier_name':
//                         vm.model.edit.supplier_name = value;

//                         if (value) {
//                             if (item?.item_id) {
//                                 vm.model.edit.supplier_no = item.item_id;
//                             }
//                         } else {
//                             vm.onTypeaheadClear('supplier_name');
//                         }
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CHANGED VALUE FUNCTION

//             // #region CLEAR VALUE FUNCTION

//             vm.onTypeaheadClear = function (id) {
//                 switch (id) {
//                     case 'prod_name':
//                         vm.model.edit.prod_id = '';
//                         vm.model.edit.prod_name = '';
//                         break;
//                     case 'supplier_name':
//                         vm.model.edit.supplier_no = '0';
//                         vm.model.edit.supplier_name = '';
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion CLEAR VALUE FUNCTION

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 equipmentEditService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             };

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'businessco_no':
//                         if (utilityService.validateWatchValue(value, vm.model.edit.businessco_no) !== true) return;

//                         vm.model.edit.businessco_no = value;

//                         if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

//                         vm.model.edit.factory_id = '';
//                         loadFactories();
//                         loadSelectWorkGroups();
//                         break;
//                     case 'factory_id':
//                         if (utilityService.validateWatchValue(value, vm.model.edit.factory_id) !== true) return;

//                         vm.model.edit.factory_id = value;

//                         if (utilityService.validateParmsValue(vm.model.edit.factory_id) !== true) return;

//                         vm.model.edit.workgrp_keyno = '0';
//                         loadSelectWorkGroups();
//                         loadStockLocations();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS
            
//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadCompanies();
//                 loadEquipmentGroupViews();
//                 loadSelectWorkGroups();
//                 loadFactories();
//                 loadStockLocations();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
